





































































































import { defineComponent, ref, onMounted, computed, watch } from '@nuxtjs/composition-api';
import { uniq, uniqBy, debounce } from 'lodash-es';
import AppAccordion from '~/components/partials/App/AppAccordion.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useStore } from '~/composables/useStore';
import { STOCK_NOTICE_BORDERLINE_COUNT } from '~/constants';
import { nonNullable } from '~/utils';
import { ECSchema } from '~/types/api';

type StoreStockSchema = ECSchema<'response.APIStoreStockIndex'>;

export default defineComponent({
  components: {
    AppAccordion,
    AppIcon,
    AppLink,
  },
  props: {
    productId: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const storeStocks = ref<StoreStockSchema['data']>();
    const currentVintage = ref('');
    const vintageCodes = ref<string[]>([]);
    const shopAreas = ref<{ id?: number; name?: string }[]>([]);
    const areaWithShops = computed(() =>
      shopAreas.value
        .map((area) => ({
          name: area.name,
          shops:
            storeStocks.value
              ?.filter((shop) => shop.sales_location?.parent_area_id === area.id)
              .map((shop) => ({
                quantity: shop.quantity || 0,
                placeCode: shop.sales_location?.place_code,
                placeLongName: shop.sales_location?.place_long_name,
                businessHours: shop.sales_location?.business_hours,
                phoneNumber: shop.sales_location?.phone_number,
                supportUberEats: shop.sales_location?.store_types?.includes('uber'),
                supportWolt: shop.sales_location?.store_types?.includes('wolt'),
              })) || [],
        }))
        .filter((area) => area.shops.length > 0)
    );

    const fetchStoreStock = async (vintage?: string) => {
      const { data } = await store.dispatch('product/detail/fetchStoreStock', {
        path: { product_id: props.productId },
        query: { vintage_code: vintage },
      });
      return data;
    };

    const changeVintage = debounce(async (vintageCode: string) => {
      currentVintage.value = vintageCode;
      storeStocks.value = await fetchStoreStock(currentVintage.value);
    }, 100);

    onMounted(async () => {
      try {
        const data = await fetchStoreStock();
        vintageCodes.value = uniq(data?.map(({ vintage }) => vintage).filter(nonNullable) || []).sort();
        currentVintage.value = vintageCodes.value[0];
        shopAreas.value = uniqBy(
          data
            ?.map((shop) => {
              if (!shop.sales_location?.parent_area_name) {
                return null;
              }
              return { id: shop.sales_location?.parent_area_id, name: shop.sales_location?.parent_area_name };
            })
            .filter(nonNullable) || [],
          'id'
        );
        storeStocks.value = await fetchStoreStock(currentVintage.value);
      } catch {
        // 何もしない
      }
    });

    watch(storeStocks, (newVal) => {
      emit('change', !newVal || newVal.length === 0);
    });

    return {
      storeStocks,
      currentVintage,
      vintageCodes,
      areaWithShops,
      changeVintage,
      STOCK_NOTICE_BORDERLINE_COUNT,
    };
  },
});
